import React from 'react';
import "./styles.scss";

function PerformerPill(props) {
  const {performerSuggestion, propClassName} = props;
  return (
    <button className={`PerformerPill ${propClassName}`}>
      {performerSuggestion.title}
    </button>
  );
}

export default PerformerPill;
